<template>
  <div class="mobile-container">
    <div class="mobile-header">
      <h1 class="mobile-title">
        <b-icon-box-seam class="title-icon"/>
        Cadastro de Produto
      </h1>
      <div class="product-type-badge"
        :class="{
          'type-agrotoxico': dataProducts.tipoProduto === 'agrotoxico',
          'type-normal': dataProducts.tipoProduto !== 'agrotoxico'
        }"
      >
        {{ dataProducts.tipoProduto === "agrotoxico" ? "AGROTÓXICO" : "NORMAL" }}
      </div>
    </div>
    
    <div class="tab-content">
      <div class="compact-section">
        <div class="section-header">
          <b-icon-box-seam class="section-icon"/>
          <span>Informações Gerais</span>
        </div>
        <div class="form-grid">
          <div class="form-group full-width">
            <input
              class="form-input"
              v-model="dataProducts.nome"
              :disabled="dataProducts.tipoProduto === 'agrotoxico'"
              placeholder=" "
            />
            <label class="form-label">Nome</label>
          </div>
          
          <div class="form-group">
            <input
              class="form-input"
              :value="maskCurrency(dataProducts.valor)"
              @input="calculateValue($event)"
              placeholder=" "
            />
            <label class="form-label">Valor de Custo</label>
          </div>

          <div class="form-group">
            <input
              class="form-input"
              :value="maskCurrency(dataProducts.valorVenda)"
              @input="calculateValueSale($event)"
              placeholder=" "
            />
            <label class="form-label">Valor de Venda</label>
          </div>
          
          <div class="form-group">
            <input
              class="form-input"
              :value="maskPercentage(dataProducts.margem1)"
              @input="calculateProfitMargin($event)"
              placeholder=" "
            />
            <label class="form-label">% Margem de Lucro</label>
          </div>
          <div class="form-group">
            <input
              class="form-input"
              :value="maskCurrency(dataProducts.lucro)"
              @input="calculateProfit($event)"
              placeholder=" "
            />
            <label class="form-label">V. Lucro</label>
          </div>

          <div class="form-group discount-wrapper">
            <InputMoney
              v-if="!discountIsCheked"
              label="Desconto"
              :labelFixed="true"
              type="text"
              :dataInput.sync="desconto"
              ref="discount"
              @calculateTotal="handleCalculateTotal"
            />
            <InputPercentage
              v-else
              label="Desconto"
              :labelFixed="true"
              type="text"
              :dataInput.sync="desconto"
              ref="discount"
              @calculateTotal="handleCalculateTotal"
            />
            <label class="modern-switch">
              <input
                type="checkbox"
                ref="typeDiscount"
                @click="alterDiscountIsCheked"
                v-model="discountIsCheked"
              />
              <div class="switch-slider">
                <span class="switch-option" :class="{active: !discountIsCheked}">R$</span>
                <span class="switch-option" :class="{active: discountIsCheked}">%</span>
              </div>
            </label>
          </div>
          
          <div class="form-group">
            <InputMoney
              label="Valor Com Desconto"
              labelFixed
              ref="valorComDesconto"
              type="text"
              isDisabled
              :dataInput.sync="dataProducts.valorDesconto"
              @calculateTotal="handleCalculateTotal"
            />
          </div>
        </div>
      </div>

        <div v-if="dataProducts.tipoProduto === 'agrotoxico'" class="compact-section">
          <div class="section-header">
            <b-icon-shield-check class="section-icon"/>
            <span>Informações Específicas para agrotóxicos</span>
          </div>
          <div class="form-grid">
            <div class="form-group">
              <input
                class="form-input"
                v-model="dataProducts.embalagem"
                :disabled="dataProducts.tipoProduto === 'agrotoxico'"
                placeholder=" "
              />
              <label class="form-label">Embalagem</label>
            </div>

            <div class="form-group">
              <input
                class="form-input"
                :value="dataProducts.lote || 'Não Informado'"
                :disabled="dataProducts.tipoProduto === 'agrotoxico'"
                placeholder=" "
              />
              <label class="form-label">Lote</label>
            </div>

            <div class="form-group">
              <input
                class="form-input"
                v-model="dataProducts.registroAgrotox"
                :disabled="dataProducts.tipoProduto === 'agrotoxico'"
                placeholder=" "
              />
              <label class="form-label">Número de Registro</label>
            </div>
          </div>
        </div>
      
      <div class="compact-section">
        <div class="section-header">
          <b-icon-card-checklist class="section-icon"/>
          <span>Estoque e identificação</span>
        </div>
        <div class="form-grid">
          <div class="form-group">
            <input
              class="form-input"
              v-model="dataProducts.codBarras"
              placeholder=" "
            />
            <label class="form-label">Cód de Barras</label>
          </div>
          
          <div class="form-group">
            <InputSelect
              label="Categorias"
              :items="categories"
              valueField="id"
              textField="nome"
              :dataSelect.sync="dataProducts.idCategoria"
              :openCreateModal="() => openModals('modalCategories')"
              ref="refCategories"
            />
          </div>
          
          <div class="form-group">
            <input
              class="form-input"
              v-model="dataProducts.codReferencia"
              placeholder=" "
            />
            <label class="form-label">Cód de Referência</label>
          </div>
          
          <div class="form-group">
            <input
              class="form-input"
              v-model="dataProducts.estoque"
              type="number"
              disabled
              placeholder=" "
            />
            <label class="form-label">Estoque</label>
          </div>
          
          <div class="form-group">
            <input
              class="form-input"
              v-model="dataProducts.estoqueMin"
              placeholder=" "
            />
            <label class="form-label">Estoque Mínimo</label>
          </div>
          
          <div class="form-group select-group">
            <b-form-select
              class="form-select"
              value-field="value"
              text-field="text"
              :options="unidade"
              v-model="dataProducts.unidade"
            />
            <label class="select-label">Unidade</label>
          </div>
        </div>
      </div>
      
      <div class="compact-section">
        <div class="section-header">
          <b-icon-journal-code class="section-icon"/>
          <span>Informações Fiscais</span>
        </div>
        <div class="form-grid">
          <div class="form-group">
            <InputSearchSelect
              label="Lista de NCM"
              :items="ncms"
              valueField="codigo_ncm"
              textField="nomeNcm"
              :dataSelect.sync="dataProducts.ncm"
              :openCreateModal="() => openModals('modalNcms')"
              ref="refNcm"
            />
          </div>
          
          <div class="form-group select-group">
            <b-form-select
              class="form-select"
              value-field="cest"
              text-field="nomeCest"
              :options="cests"
              v-model="dataProducts.cest"
            />
            <label class="select-label">Lista de CEST</label>
          </div>
          
          <div class="form-group">
            <input
              class="form-input"
              v-model="dataProducts.nomeCest"
              placeholder=" "
            />
            <label class="form-label">Descrição CEST</label>
          </div>
          
          <div class="form-group">
            <input
              class="form-input"
              v-model="dataProducts.cest"
              @input="handleNcmOrCest(dataProducts.cest)"
              placeholder=" "
            />
            <label class="form-label">Novo CEST</label>
            <button
              class="action-btn info-btn"
              v-b-popover.hover.top="
                'O CEST é um código numérico que identifica produtos sujeitos à substituição tributária, facilitando o cálculo de impostos sobre eles. Exemplo : 28.064.00'
              "
            >
              <b-icon-question-circle-fill/>
            </button>
          </div>
        </div>
        <div class="rowRefFiscal">
          <div class="input-group-ob">
            <InputSearchSelect
              style="width: 100%"
              label="REF. Fiscal"
              :items="refsFiscaisFromSelectBox"
              valueField="ref"
              textField="descricao"
              :dataSelect.sync="dataProducts.refFiscal"
              :enableIconCreate="false"
              ref="refFiscal"
            />
          </div>
          <div style="width: 30%" class="refFiscalMobile">
            <b-button
              class="btnsRefFiscal"
              @click="openModals('modalTaxInformation')"
            >
              <b-icon-plus-square></b-icon-plus-square> Nova Info.Fiscal
            </b-button>
          </div>
        </div>
      </div>

      
      <div class="compact-section">
        <div class="section-header">
          <b-icon-info-circle class="section-icon"/>
          <span>Observações</span>
        </div>
        <div class="form-grid">
          <div class="form-group full-width">
            <textarea
              class="form-textarea"
              v-model="dataProducts.descricao"
              placeholder=" "
            />
            <label class="form-label">Observações</label>
          </div>
          
          <div class="form-group select-group">
            <b-form-select
              class="form-select"
              value-field="value"
              text-field="text"
              :options="status"
              v-model="dataProducts.status"
              :disabled="!dataProducts.id"
            />
            <label class="select-label">Status</label>
          </div>
        </div>
      </div>

      <div class="action-buttons">
        <button class="btn-secondary" @click="clear">
          <b-icon-arrow-clockwise/>
          Novo
        </button>
        <div class="stock-actions" v-if="!stockAdjustmentIsEnable">
          <button
            class="btn-stock"
            @click="$bvModal.show('modal-ajustStock')"
          >
            <b-icon-plus/>
            Ajustar estoque
          </button>
        </div>
        <button class="btn-primary" @click="saveOrUpdateProducts">
          <b-icon-check2-circle/>
          {{ dataProducts.id ? "Atualizar" : "Salvar" }}
        </button>
      </div>
    </div>

    <ModalTaxInformation @createdNewRef="createdNewRef = $event" />
    <ModalCreateCategory @getNewCategory="findAllCategories" />
    <ModalCreateNcm @getNewNcm="ncmCombobox" />

    <b-modal
      id="modal-ajustStock"
      hide-footer
      hide-header
      centered
      title="Stock"
    >
      <div>
        <h6 class="titleModal">Digite a nova quantidade do estoque:</h6>
        <div class="contentModal">
          <div class="input-group" style="width: 45%">
            <b-form-input
              required
              class="input borderInput"
              v-model="stockAmount"
            />
            <label class="user-label"> Novo Estoque </label>
          </div>

          <div class="input-group" style="width: 45%">
            <b-form-input
              required
              disabled
              class="input borderInput"
              v-model="dataProducts.estoque"
            />
            <label class="fixedSelect2"> Estoque Atual </label>
          </div>
        </div>
        <div class="btnModal">
          <button class="btnContent" @click="handleStockAdjustment">
            Atualizar Estoque
          </button>
          <button
            class="btnContentReceive"
            @click="$bvModal.hide('modal-ajustStock')"
          >
            Cancelar
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import mixinProducts from "../../mixins/Products/Products";
export default {
  mixins: [mixinProducts],
};
</script>
<style scoped>
.mobile-container {
  padding: 8px;
  max-width: 100vw;
  overflow-x: hidden;
}

.mobile-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  margin-bottom: 12px;
  border-bottom: 2px solid #e8f5e8;
}

.mobile-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 18px;
  font-weight: 700;
  color: #2d5016;
  margin: 0;
}

.title-icon {
  color: #4caf50;
}

.product-type-badge {
  padding: 4px 12px;
  border-radius: 16px;
  font-size: 10px;
  font-weight: 600;
  color: white;
  text-transform: uppercase;
}

.product-type-badge.type-agrotoxico {
  background: linear-gradient(135deg, #006256, #00876e);
}

.product-type-badge.type-normal {
  background: linear-gradient(135deg, #666, #888);
}

.tab-content {
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}

.compact-section {
  background: linear-gradient(135deg, #fafafa, #f5f5f5);
  border-radius: 12px;
  padding: 12px;
  margin-bottom: 12px;
  border: 1px solid #e0e0e0;
}

.section-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  padding-bottom: 6px;
  border-bottom: 1px solid #e8e8e8;
}

.section-icon {
  color: #4caf50;
  font-size: 16px;
}

.section-header span {
  font-size: 14px;
  font-weight: 600;
  color: #333;
}

.form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}

.form-group {
  position: relative;
  min-height: 35px;
}

.form-group.full-width {
  grid-column: 1 / -1;
}

.discount-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
}

.discount-wrapper > :first-child {
  flex: 1;
}

.modern-switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 32px;
  margin-top: 8px;
}

.modern-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.switch-slider {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #e0e0e0;
  border-radius: 16px;
  transition: all 0.3s;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px;
  cursor: pointer;
}

.switch-slider:before {
  content: '';
  position: absolute;
  height: 20px;
  width: 20px;
  left: 6px;
  top: 6px;
  background: white;
  border-radius: 50%;
  transition: all 0.3s;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  z-index: 2;
}

.modern-switch input:checked + .switch-slider {
  background: #4caf50;
}

.modern-switch input:checked + .switch-slider:before {
  transform: translateX(28px);
}

.switch-option {
  font-size: 10px;
  font-weight: 700;
  color: #666;
  z-index: 3;
  transition: color 0.3s;
  padding: 0;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  position: relative;
}

.switch-option.active {
  color: #4caf50;
}

.form-group.ncm-group {
  display: flex;
  align-items: center;
  gap: 8px;
}

.form-input, .form-select, .form-textarea {
  width: 100%;
  height: 35px;
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 16px;
  background: white;
  transition: all 0.2s ease;
  outline: none;
}

.form-input:focus, .form-select:focus, .form-textarea:focus {
  border-color: #4caf50;
  box-shadow: 0 0 0 2px rgba(76, 175, 80, 0.1);
  transform: translateY(-1px);
}

.form-label, .select-label {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 12px;
  color: #666;
  background: white;
  padding: 0 4px;
  pointer-events: none;
  transition: all 0.2s ease;
  white-space: nowrap;
  z-index: 1;
}

.form-input:focus + .form-label,
.form-input:not(:placeholder-shown) + .form-label,
.form-select:focus + .select-label,
.form-select:not([value=""]) + .select-label {
  top: 0;
  transform: translateY(-50%) scale(0.85);
  color: #4caf50;
  font-weight: 600;
}

.action-btn {
  position: absolute;
  right: 4px;
  top: 50%;
  transform: translateY(-50%);
  width: 28px;
  height: 28px;
  border: none;
  border-radius: 6px;
  background: linear-gradient(135deg, #4caf50, #66bb6a);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 12px;
}

.action-btn.info-btn {
  background: linear-gradient(135deg, #2196f3, #42a5f5);
}

.action-buttons {
  display: flex;
  gap: 12px;
  margin: 16px 0;
  padding: 0 4px;
}

.btn-primary, .btn-secondary {
  flex: 1;
  height: 44px;
  padding: 6px;
  border: none;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-primary {
  background: linear-gradient(135deg, #4caf50, #66bb6a);
  color: white;
  box-shadow: 0 2px 8px rgba(76, 175, 80, 0.3);
}

.btn-primary:hover {
  background: linear-gradient(135deg, #43a047, #5cb85c);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(76, 175, 80, 0.4);
}

.btn-secondary {
  background: linear-gradient(135deg, #f5f5f5, #e0e0e0);
  color: #333;
  border: 1px solid #ddd;
}

.btn-secondary:hover {
  background: linear-gradient(135deg, #eeeeee, #d5d5d5);
  transform: translateY(-1px);
}

.select-group .form-select {
  padding-right: 30px;
}

@media (max-width: 480px) {
  .mobile-container {
    padding: 4px;
  }
  
  .form-grid {
    grid-template-columns: 1fr;
    gap: 6px;
  }
  
  .mobile-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }
  
  .action-buttons {
    flex-direction: column;
  }
}

@media (min-width: 768px) {
  .form-grid {
    grid-template-columns: 1fr 1fr 1fr;
  }
  
  .mobile-container {
    max-width: 800px;
    margin: 0 auto;
    padding: 16px;
  }
}

.form-input:disabled,
.form-select:disabled {
  background-color: #f5f5f5;
  cursor: not-allowed;
  opacity: 0.7;
}

*:focus {
  outline: none;
}

.form-input:focus,
.form-select:focus,
.btn-primary:focus,
.btn-secondary:focus {
  outline: 2px solid #4caf50;
  outline-offset: 2px;
}

/* Estilos específicos herdados que podem ser necessários */
.form-control:focus {
  background-color: transparent;
  box-shadow: none !important;
  border: 1px solid #4caf50 !important;
}

.form-control {
  border-radius: 8px !important;
}

.containerCard {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: none;
  padding: 0px 0px 20px 0px;
  border-bottom: 1px solid rgb(231, 231, 231);
}

.form-control-sm {
  height: 28px;
  padding: 0.25rem 0.25rem;
  font-size: 12px;
  line-height: 1.3;
  border-radius: 0.2rem;
  color: red !important;
  border: none !important;
}

.custom-select-sm {
  height: 28px;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  font-size: 12px;
}

.contentIconsStock {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.25rem;
  max-height: 29px;
  width: 71px;
}

.contentIcons {
  height: 100%;
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.iconsStockCancel {
  color: red;
}
.iconsStockConfirm {
  color: #00aa62;
}

.form-group {
  margin-bottom: 0.2rem;
}

span {
  font-weight: bold;
  cursor: context-menu;
}

.user-label {
  position: absolute;
  left: 10px;
  font-size: 11px;
  z-index: 30;
  bottom: 7px;
  pointer-events: none;
  transform: translateY(0.5rem);
  transition: 150ms cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap !important;
  text-overflow: ellipsis;
  color: #666360;
}

.user-label-ob {
  position: absolute;
  left: 40px;
  font-size: 11px;
  pointer-events: none;
  transform: translateY(0.5rem);
  transition: 150ms cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap !important;
  text-overflow: ellipsis;
  color: #666360;
}

.input {
  font-size: 12px !important;
  width: 100%;
}

.inputDisabled {
  background-color: #fafafa;
  pointer-events: none;
  color: #949290 !important;
}

.input:focus ~ label,
input:valid ~ label {
  transform: translateY(-50%) scale(0.8);
  background-color: #ffffff;
  padding: 0 0.1em;
  font-weight: 600;
}

.form-control:focus {
  background-color: #ffffff00;
  box-shadow: none !important;
  border: 1px solid black !important;
}

.form-control {
  border-radius: 5px !important;
}

.selectPlus {
  position: relative;
  width: 30%;
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: center;
}

.questionBtn {
  display: flex;
  justify-content: center;
  height: 30px;
  position: absolute;
  right: 0px;
  font-size: 11px;
  z-index: 2;
  cursor: pointer;
  color: black;
  border-radius: 5px;
  border: none;
  background: #c3c3c3;
  align-items: center;
}
.slider:before {
  position: absolute;
  content: "R$";
  font-size: 10px;
  height: 82%;
  width: 44%;
  left: 6%;
  border-radius: 50px;
  background-color: #00aa62;
  color: white;
  display: grid;
  align-content: center;
  justify-content: center;
  transition: 0.4s;
  font-weight: bold;
}

.slider:after {
  content: "";
  position: absolute;
  z-index: -1;
}

.switch input {
  display: none;
}

.fixedSelect {
  position: absolute;
  margin-bottom: 0px;
  font-size: 10px;
  bottom: 24px;
  left: 20px;
  z-index: 2;
  text-transform: capitalize;
  color: rgb(85, 81, 81);
  background-color: transparent;
}
.fixedSelect2 {
  position: absolute;
  margin-bottom: 0px;
  font-size: 10px;
  bottom: 22px;
  left: 11px;
  z-index: 2;
  text-transform: capitalize;
  color: rgb(85, 81, 81);
  background-color: white;
  font-weight: 600;
}

.custom-select {
  display: inline-block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 1.75rem 0.375rem 0.75rem;
  font-size: 11px !important;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  vertical-align: middle;
  background: none;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

.borderInput {
  font-size: 14px;
  height: 30px;
  border: 1px solid #b2b2b2;
  border-radius: 5px;
  outline: none;
  transition: ease-in 0.1s all;
  padding-left: 5px;
  padding-right: 4px;
  color: #5c5855;
}

.borderInput:focus {
  border: 1px solid #505050;
}

.iconSelect {
  position: absolute;
  right: 0px !important;
  z-index: 10;
  background-color: #c1c1c1;
  color: whitesmoke;
  height: 30px;
  width: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0.25rem;
  cursor: pointer;
}

.title {
  font-size: 16px;
  color: rgb(95, 95, 95);
  margin-bottom: 20px;
  border-bottom: 1px solid rgb(230, 230, 230);
  font-weight: 600;
}

.rowContainer {
  position: relative;
  border: 1px solid rgb(230, 230, 230);
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  padding: 10px 10px 5px 10px;
  background: #f9f9f94d;
  margin-bottom: 10px;
}

.rowContainer span {
  font-weight: 600;
}

.rowContainerComposition {
  border: 1px solid rgb(230, 230, 230);
  border-radius: 5px;
  padding: 10px 10px 5px 10px;
  margin-bottom: 10px;
  transition: ease-in all 0.3s;
  /* margin-left: 3rem; */
}

.rowContainerComposition span {
  font-weight: 600;
  font-size: 11px;
}

.contentModal {
  display: flex;
  padding: 15px 0px 5px 0px;
  justify-content: space-around;
}

.btnModal {
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.btnContent {
  font-size: 11px;
  border: 1px solid #006256;
  border-radius: 3px;
  width: 45%;
  height: 28px;
  position: relative;
  color: #ffffff;
  background: #006256;
}

.btnContentReceive {
  font-size: 11px;
  border: 1px solid #006256;
  border-radius: 3px;
  width: 45%;
  height: 28px;
  position: relative;
  color: #006256;
  background: white;
}

.titleModal {
  font-size: 1rem;
  border-bottom: 1px solid #e6e7e8;
  font-weight: bold;
}

.rowContentNcm {
  display: flex;
  width: 100%;
  padding: 10px 0 5px 0;
  justify-content: flex-start;
  gap: 10px;
}

.questionNcmBtn {
  display: flex;
  justify-content: center;
  height: 30px;
  font-size: 11px;
  z-index: 2;
  cursor: pointer;
  color: black;
  border-radius: 5px;
  border: none;
  background: #c3c3c3;
  align-items: center;
}

.rowContent {
  display: flex;
  width: 100%;
  padding: 10px 0 5px 0;
  justify-content: space-between;
  gap: 10px;
}
.rowObservation {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 40px;
  padding: 10px 0 5px 0;
  gap: 30px;
}

.rowRefFiscal {
  display: flex;
  width: 100%;
  padding: 10px 0 5px 0;
  height: 40px;
  gap: 30px;
}

.btnsContainer {
  gap: 20px;
  display: flex;
  width: 100%;
  justify-content: space-between;
}

.btnContainerComposition {
  display: flex;
  justify-content: flex-end;
  width: 100%;
}

.btnsAddComposition {
  display: flex;
  align-items: center;
  position: absolute;
  top: 5px;
  right: 10px;
  border-radius: 5px;
  background-color: #006256;
  border: none;
  color: white;
  font-size: 11px;
  padding: 0.1rem 0.8rem;
}

.btnsSave {
  border-radius: 5px;
  background-color: #006256;
  width: 165px;
  border: none;
  margin-top: 30px;
  color: white;
  font-size: 12px;
  font-weight: 600;
}

.ajustStock {
  display: flex;
  margin-top: 30px;
}

.btnsSaveNeutral {
  border-radius: 5px;
  background-color: #f9f9f9;
  width: 165px;
  border: 1px solid gray;
  margin-top: 30px;
  color: rgb(0, 0, 0);
  font-size: 12px;
  font-weight: 600;
}
.btnsRefFiscal {
  border-radius: 5px;
  background-color: #d7d7d7;
  width: 100%;
  border: none;
  color: rgb(0, 0, 0);
  font-size: 12px;
  font-weight: 600;
}

.input-group {
  width: 30%;
}

.input-group-ob {
  width: 70%;
}

.input-group-stock {
  width: 70%;
}

.card-body {
  flex: 1 1 auto;
  min-height: 1px;
  padding: 0 1rem 0 1rem;
}

.card {
  border: none !important;
}

.enabledComposition {
  display: block;
}

.closeComposition {
  display: none;
  overflow: hidden;
}

@media screen and (max-width: 700px) {
  .rowContent {
    display: flex;
    width: 100%;
    padding: 5px 0 5px 0;
    justify-content: space-between;
    gap: 10px;
    flex-direction: column;
  }

  .input-group {
    width: 100%;
  }

  .input-group-ob {
    width: 50%;
  }

  .selectPlus {
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: row;
    gap: 20px;
    align-items: center;
  }

  .refFiscalMobile {
    width: 50% !important;
  }

  .btn {
    padding: 0.375rem 0.5rem;
  }
}

.stock-actions {
  display: flex;
  align-items: center;
}

.btn-stock {
  width: 100%;
  padding: 6px;
  border: none;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  background: linear-gradient(135deg, #00aa62, #00c46a);
  color: white;
  box-shadow: 0 2px 8px rgba(0, 170, 98, 0.3);
}

.btn-stock:hover {
  background: linear-gradient(135deg, #009956, #00aa62);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 170, 98, 0.4);
}

/* Estilo específico para grupo de informação independente */
.form-group.info-only {
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: center;
}

.action-btn.standalone {
  position: relative;
  transform: none;
  margin: 0;
}

.info-text {
  font-size: 12px;
  color: #666;
  font-weight: 500;
}

/* Estilo para NCM com ícone de ajuda */
.form-group.ncm-with-help {
  position: relative;
  grid-column: 1 / -1;
}

/* Estilos para o modal de ajuste de estoque */
.titleModal {
  font-size: 1rem;
  border-bottom: 1px solid #e6e7e8;
  font-weight: bold;
  margin-bottom: 15px;
}

.contentModal {
  display: flex;
  padding: 15px 0px 5px 0px;
  justify-content: space-around;
}

.btnModal {
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.btnContent {
  font-size: 11px;
  border: 1px solid #006256;
  border-radius: 3px;
  width: 45%;
  height: 28px;
  position: relative;
  color: #ffffff;
  background: #006256;
}

.btnContentReceive {
  font-size: 11px;
  border: 1px solid #006256;
  border-radius: 3px;
  width: 45%;
  height: 28px;
  position: relative;
  color: #006256;
  background: white;
}

/* Estilos legados que podem ser necessários */
.input-group {
  width: 30%;
}

.user-label {
  position: absolute;
  left: 10px;
  font-size: 11px;
  bottom: 7px;
  pointer-events: none;
  transform: translateY(0.5rem);
  transition: 150ms cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap !important;
  text-overflow: ellipsis;
  color: #666360;
}

.fixedSelect2 {
  position: absolute;
  margin-bottom: 0px;
  font-size: 10px;
  bottom: 22px;
  left: 11px;
  z-index: 2;
  text-transform: capitalize;
  color: rgb(85, 81, 81);
  background-color: white;
  font-weight: 600;
}

.borderInput {
  font-size: 14px;
  height: 30px;
  border: 1px solid #b2b2b2;
  border-radius: 5px;
  outline: none;
  transition: ease-in 0.1s all;
  padding-left: 5px;
  padding-right: 4px;
  color: #5c5855;
}

.borderInput:focus {
  border: 1px solid #505050;
}

.input {
  font-size: 12px !important;
  width: 100%;
}
</style>
